exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-68047b6e]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #efefef;\n}\n\n/* Mixins */\n.sw-update-popup > button[data-v-68047b6e] {\n  margin-top: 0.5em;\n  padding: 0.25em 1.5em;\n}", ""]);

